export default {
  en: {
    newAgent: 'New Agent',
    agentName: 'Name',
    type: 'Type',
    pleaseSelectType: 'Please select type',
    otherType: '- Other -',
    status: 'Status',
    cancel: 'Cancel',
    create: 'Create Agent',
    createAgentSuccessTitle: 'Success',
    createAgentSuccessMessage: 'Create Agent Success.'
  },
  th: {
    newAgent: 'สร้างตัวแทน',
    agentName: 'ชื่อ',
    type: 'ประเภท',
    pleaseSelectType: 'กรุณาเลือกประเภท',
    otherType: '- อื่นๆ -',
    status: 'สถานะ',
    cancel: 'ยกเลิก',
    create: 'สร้างตัวแทน',
    createAgentSuccessTitle: 'สำเร็จ',
    createAgentSuccessMessage: 'สร้างตัวแทนสำเร็จ'
  }
}
